import { withEventContext } from "@codat/analytics";
import { Modal } from "@codat/orchard-ui";
import { useConfig } from "contexts/ConfigContext";
import useCompleteRedirect from "hooks/useCompleteRedirect";
import { useGATrackingEvent } from "hooks/useGATracking";
import { SourceType } from "model";

import { WarningDialogWithoutEventContext } from "components/WarningDialog/WarningDialog";

import styles from "./ExitModal.module.css";

interface ExitModalProps {
  isOpen: boolean;
  onClose: () => void;
  companyId: string;
  sourceType: SourceType | undefined;
}

const ExitModalContent: React.FC<ExitModalProps> = ({
  isOpen = false,
  onClose = () => {
    // default exit modal close handler
  },
  companyId,
  sourceType,
}) => {
  const { state } = useConfig();
  const { logGAEvent } = useGATrackingEvent();

  const handleExitClick = () => {
    logGAEvent("Link Flow", "ExitCTA", companyId);
    redirect();
  };

  const redirect = useCompleteRedirect({
    companyId,
    sourceType: sourceType ?? "",
    statusCode: 403,
  });

  return (
    <Modal
      className={styles.modal}
      onClose={onClose}
      data-testid="exit-modal-container"
    >
      {isOpen && (
        <WarningDialogWithoutEventContext
          title={
            state.data?.pageConfiguration.exit?.title ?? "Do you want to exit?"
          }
          subText={state.data?.pageConfiguration.exit?.body}
          primaryCtaProps={{
            label: "Continue linking",
            onClick: onClose,
            analyticsName: "Continue linking",
          }}
          secondaryCtaProps={{
            label: "Exit",
            onClick: handleExitClick,
            analyticsName: "Exit",
            eventProperties: { sourceType },
          }}
          data-testid="exit-modal"
        />
      )}
    </Modal>
  );
};

export const ExitModal = withEventContext<
  ExitModalProps & JSX.IntrinsicAttributes
>(ExitModalContent, "Exit modal");
